import { UnderlineSVG } from "@/components/icons/HomePage";
import { HeaderSubheaderComponent } from "@/pages/partners/[partnerName]";

const defaultStatCards = [
  {
    header: "1,000+",
    subheader: "home-service pros helped",
  },
  {
    header: "32,000+",
    subheader: "leads generated",
  },
  {
    header: "6 million+",
    subheader: "pageviews for customers",
  },
];

const Stats = ({ statCards }: { statCards?: HeaderSubheaderComponent[] }) => {
  const normalizedStatCards = statCards?.map((card) => ({
    header: card.fields.header,
    subheader: card.fields.subheader,
  }));

  const statCardsToDisplay = normalizedStatCards || defaultStatCards;

  return (
    <div className="bg-black text-white px-5 md:px-16 md:py-28 py-16">
      <div className="flex flex-col gap-10 max-w-7xl mx-auto relative">
        <div className="flex flex-col gap-14 w-full max-w-[200px] md:max-w-none">
          <h3 className="font-clash font-semibold text-4xl md:text-5xl leading-[1.1] tracking-snug text-white relative">
            Rebolt in{" "}
            <span className="relative inline-block">
              numbers
              <span className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-full">
                <UnderlineSVG className="w-full" />
              </span>
            </span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-6 w-full text-white">
          {statCardsToDisplay.map((card) => (
            <div key={card.header} className="flex flex-col gap-2 bg-ash-800 rounded-3xl p-8 lg:p-10 ">
              <h4 className="font-bold text-5xl md:text-6xl tracking-tight">{card.header}</h4>
              <p className="text-xl text-ash-100 font-semibold">{card.subheader}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Stats;
